"use strict";

var _classCallCheck = require("/Users/Pablo/Nnodes/fundacion_tests_frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/Pablo/Nnodes/fundacion_tests_frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rawTaskJs = require("./RawTask.js");

var TaskFactory = /*#__PURE__*/function () {
  _createClass(TaskFactory, [{
    key: "create",
    value: function create(task) {
      var tasks = this.freeTasks;
      var t1 = tasks.length ? tasks.pop() : new _rawTaskJs.RawTask(this.onError, function (t) {
        return tasks[tasks.length] = t;
      });
      t1.task = task;
      return t1;
    }
  }]);

  function TaskFactory(onError) {
    _classCallCheck(this, TaskFactory);

    this.onError = onError;
    this.freeTasks = [];
  }

  return TaskFactory;
}();

exports.TaskFactory = TaskFactory;